import React from 'react';
import Head from 'next/head';
import styles from './About.module.scss';
import ButtonPill from '../src/legacy/components/util/ButtonPill/ButtonPill';

/*
OLD DESCRIPTION
Bounce provides a payment platform that facilitates event ticketing and P2P
payments through an intuitive mobile app and professional web app. The platform
caters to a seamless event user experience through integration with ridesharing
and social media applications while enabling the customer to “operate cashless”
and pay for event tickets via their mobile phones. Event hosts benefit from
unique QR code generation and ticket scanning options as well as customer data
analytics and location-based event marketing.{" "}

Additionally, Bounce’s event upgrades provide hosts with unique features such as
event photo galleries, attendee polling, and the ability to provide text updates
to attendees. Finally, Bounce’s comprehensive platform also enables users to
split bills and repay each other through an intuitive fund transfer system.
*/
export const About: React.FC = () => (
  <div className={styles.About}>
    <Head>
      <title>About Us | Bounce</title>
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://bouncelife.com/about" />
      <meta property="og:title" content="About Us | Bounce" />
      <meta property="fb:app_id" content="1855802768063770" />
      <meta
        property="og:image"
        content="/img/illustrations/landing/about-image.jpg"
      />
      <meta
        property="og:description"
        content="Bounced Inc. is a fin-tech startup that is redefining in-person events. Our platform is centred around event ticketing, increasing guest engagement, and creating communities on campus. We are the one-stop-shop for all your social event needs, and we can even handle custom apparel and drink sponsorships through our partners."
      />
    </Head>
    <div className={styles.HeaderBanner}>
      <div className={styles.Container}>
        <h1>Why Bounce?</h1>
        <p>
          We are redefining the events hosting landscape, and giving you an
          interactive experience that extends beyond the event stage.
        </p>
        <ButtonPill type="ButtonWhiteWide" pb="50px" link="/dashboard">
          Get Started
        </ButtonPill>
      </div>
    </div>
    <div className={styles.OurStory}>
      <div className={styles.Container}>
        <h2>Our Story</h2>
        <div className={styles.SectionHeadlineReverse}>
          <img src="/img/illustrations/landing/about-image.jpg" alt="About" />
          <div className={styles.Description}>
            <p>
              Bounce is a socially integrated platform that bundles and
              comprehensively spans users’ weekly event needs. Centred around
              event ticketing, increasing user-user engagement, and building
              communities, we are the one-stop shop for all your social event
              needs where we even handle custom apparel and drink sponsorships
              through our corporate partners.
            </p>
            <p>
              Born out of the realization that the event ticketing space is
              highly fragmented and costly, we set out to improve and redefine
              the event experience for both hosts and guests. Through our deep
              understanding of the university event space and what really
              matters to our users, we&apos;ve built Bounce to be the best
              solution for university students to organize and attend events!
            </p>
          </div>
        </div>
        <div className={styles.AboutImages}>
          <img src="/img/illustrations/landing/about-1.jpg" alt="About" />
          <img src="/img/illustrations/landing/about-2.jpg" alt="About" />
          <img src="/img/illustrations/landing/about-3.jpg" alt="About" />
        </div>
      </div>
    </div>
    <div style={{ backgroundColor: '#fff', width: '100%' }}>
      <div className={styles.Container}>
        <h2 style={{ paddingTop: '50px' }}>Our Initiatives</h2>
        <div className={styles.OurInitiatives}>
          <div className={styles.Initiative}>
            <h3>Creating Communities & Memories</h3>
            <img
              src="/img/illustrations/landing/bounce-ball.svg"
              alt="Bounce"
            />
            <p>
              At Bounce, we’re helping university students build communities,
              make new connections, and create lasting memories.
            </p>
          </div>
          <div className={styles.Initiative}>
            <h3>Supporting Our Ecosystem</h3>
            <img
              src="/img/illustrations/landing/bounce-ball.svg"
              alt="Bounce"
            />
            <p>
              We’re deeply integrated in our communities and are committed to
              supporting both student organizations and local businesses.
            </p>
          </div>

          <div className={styles.Initiative}>
            <h3>Bouncing for Better</h3>
            <img
              src="/img/illustrations/landing/bounce-ball.svg"
              alt="Bounce"
            />
            <p>
              From tree replanting to fundraising for causes like BLM and
              Movember, we love giving back and using the platform to enact
              positive change.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div className={styles.HostEvent}>
      <h2>Host an Event with Bounce today.</h2>
      <ButtonPill type="ButtonWhiteWide" link="/dashboard">
        Get Started
      </ButtonPill>
    </div>
  </div>
);

export async function getStaticProps() {
  return {
    props: {} // will be passed to the page component as props
  };
}

export default About;
